module.exports = __webpack_public_path__ + "static/media/IMG_20190826_180655.thumbnail.1c780859.png";